<script setup>
import { computed } from 'vue';
import SolarIcon from './SolarIcon.vue';
import { navSolarIcon } from './solarIcons';

// Ícone da navegação principal: os dados seguem com a classe Phosphor e aqui
// ela vira o Solar animado. Marca (WhatsApp, Instagram) e ícone próprio
// (i-woot-*) não têm Solar e continuam como classe.
const props = defineProps({
  icon: { type: String, default: '' },
  active: { type: Boolean, default: false },
});

const solarName = computed(() => navSolarIcon(props.icon));
</script>

<template>
  <SolarIcon v-if="solarName" :name="solarName" :active="active" />
  <span v-else :class="icon" aria-hidden="true" />
</template>
